import type { Node } from '@xyflow/react';
import type { OutputsResolver, WidgetNodeData } from '../../widgets/types';

export function handleSignatures(nodes: Node<WidgetNodeData>[], outputsFor: OutputsResolver) {
  return new Map(
    nodes.map((n) => [
      n.id,
      (outputsFor(n.type ?? '', n.data.config) ?? []).map((h) => `${h.id}@${h.position}`).join('|'),
    ]),
  );
}

export function changedHandleNodeIds(previous: Map<string, string>, next: Map<string, string>) {
  return [...next.entries()]
    .filter(([id, signature]) => previous.has(id) && previous.get(id) !== signature)
    .map(([id]) => id);
}
